export const AISettingsScopeProperty = {
  default_translate_language: 'default_translate_language'
} as const;

export interface AISettingsScope {
  [AISettingsScopeProperty.default_translate_language]?: string;
}
